import { render, staticRenderFns } from "./TempReport.vue?vue&type=template&id=596ff2ab"
import script from "./TempReport.vue?vue&type=script&lang=js"
export * from "./TempReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports